import { request } from "@/plugins/axios";

export function getQrCode() {
    return request({
     url: `/portal/highTalents/getQrCode`
   });
 }

 export function getData  () {
    return request({
      url: `/portal/highTalents/info`
    });
 }

 export function addData(data){
  return request({
    method: 'post',
    url: `/portal/highTalents/add`,
    data,
  });
}

export function updateData(data){
  return request({
    method: 'post',
    url: `/portal/highTalents/update`,
    data
  });
}
/** 获取平台的高端人才列表 */
export function getListData (params = {}) {
  return request({
    url: '/portal/highTalents/h5/list',
    params,
  });
}